import { ReactNode } from "react";
import styled from "styled-components";

import { Box, Heading } from "@vinomofo/components";

const RichTextWrapper = styled(Box)`
  * + * {
    margin-top: 1em;
  }
`;

interface RichTextBlockProps {
  heading?: string;
  subheading?: string;
  bodyText: ReactNode;
}

export const RichTextBlock = ({
  heading,
  subheading,
  bodyText,
}: RichTextBlockProps): JSX.Element => {
  return (
    <RichTextWrapper px={[0, `${(1 / 6) * 100}%`]} py="2em">
      {heading && (
        <Heading variant="md" as="h2">
          {heading}
        </Heading>
      )}
      {subheading && (
        <Heading variant="sm" as="h3" fontWeight="500" color="brand">
          {subheading}
        </Heading>
      )}
      {bodyText}
    </RichTextWrapper>
  );
};
